module.exports = __webpack_public_path__ + "assets/img/my-vip-cont2.f24c1eea.png";